module.exports = __webpack_public_path__ + "static/shopify-37e4cf05b4fd57c8059b4a875e94956e.png";